module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/social/linkedin-03f1d164221e3a81954e6ec24a350288.svg";